var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15.5,
    r: 15.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.283 11.2L11.443 13.7L9.74305 11.74L14.363 7.84H17.163V22H14.283V11.2ZM21.679 20.28C21.679 20.0267 21.7257 19.7867 21.819 19.56C21.9123 19.3333 22.039 19.14 22.199 18.98C22.3723 18.8067 22.5723 18.6733 22.799 18.58C23.0257 18.4867 23.2657 18.44 23.519 18.44C23.7723 18.44 24.0123 18.4867 24.239 18.58C24.4657 18.6733 24.659 18.8067 24.819 18.98C24.9923 19.14 25.1257 19.3333 25.219 19.56C25.3123 19.7867 25.359 20.0267 25.359 20.28C25.359 20.5333 25.3123 20.7733 25.219 21C25.1257 21.2267 24.9923 21.4267 24.819 21.6C24.659 21.76 24.4657 21.8867 24.239 21.98C24.0123 22.0733 23.7723 22.12 23.519 22.12C23.2657 22.12 23.0257 22.0733 22.799 21.98C22.5723 21.8867 22.3723 21.76 22.199 21.6C22.039 21.4267 21.9123 21.2267 21.819 21C21.7257 20.7733 21.679 20.5333 21.679 20.28Z",
    fill: "#6B51EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep1);
export default __webpack_public_path__ + "static/media/step1.9d60ab3bc0f8d6e61cc0b483866ed543.svg";
export { ForwardRef as ReactComponent };